import config from "utils/globals";
import { digitsArToFa, digitsFaToEn } from "@persian-tools/persian-tools";

export const PMA_STAGES = {
  AMOUNT: "amount",
  PAYMENT: "payment",
  RISK: "risk",
  SIGN_CONTRACT: "sign_contract",
  CREATING_PRX: "create_prx",
  ADDITIONAL_AMOUNT: "additional_amount",
  STAGES: "stages",
};

export const CONTRACT_STATUS = {
  LIST: "list",
  VIEW: "view",
  OTP: "opt",
};

export const ADDITIONAL_AMOUNT_STATUS = {
  RECEIPT: "receipt",
  FORM: "form",
};

const handleStatusType = (type) => {
  switch (type) {
    // case "BLOCKED":
    // case "FAILED":
    //   return "error";
    case "ACTIVE":
      return "wait";
    case "DONE":
      return "finish";
    default:
      return "";
  }
};

const handleActionsSteps = (
  item,
  { currentStage, onChangeContractStates, goToCurrentStage, t }
) => {
  if (
    item.status === "DONE" &&
    item.info_status === "OPEN" &&
    `${item.key}`.toLowerCase() === PMA_STAGES.RISK
  )
    return (
      <div
        className="text-blue-0 caption-12px-regular cursor-pointer"
        onClick={() => goToCurrentStage("RISK")}
      >
        {t("edit")}
      </div>
    );

  if (
    item.status === "DONE" &&
    item.info_status === "LOCK" &&
    `${item.key}`.toLowerCase() === PMA_STAGES.SIGN_CONTRACT
  )
    return (
      <div
        className="text-blue-0 caption-12px-regular cursor-pointer"
        onClick={() => {
          onChangeContractStates(CONTRACT_STATUS.LIST);
          goToCurrentStage("SIGN_CONTRACT");
        }}
      >
        {t("show")}
      </div>
    );

  if (
    item.status === "DONE" &&
    item.info_status === "LOCK" &&
    `${item.key}`.toLowerCase() === PMA_STAGES.CREATING_PRX
  )
    return (
      <div className="text-warning-0 caption-12px-regular">
        {t("pma-onboarding.waiting-for-confirm")}
      </div>
    );

  if (
    item.status === "ACTIVE" &&
    item.info_status === "OPEN" &&
    currentStage === PMA_STAGES.ADDITIONAL_AMOUNT
  )
    return (
      <div className="text-warning-0 caption-12px-regular">
        {t("pma-onboarding.waiting-for-paid")}
      </div>
    );
};

const handleProcessStatus = (item, stepStage) => {
  const status =
    stepStage === item.sort && item.status === "ACTIVE"
      ? "process"
      : handleStatusType(item.status);

  return !item.status === "FAILED" ? status : "";
};

export const stagesDataTransformer = (
  input,
  stepStage,
  { onChangeContractStates, goToCurrentStage, t }
) => {
  const data = [];
  config.sortArray(input?.stages, "sort")?.map((item) =>
    data.push({
      status: handleProcessStatus(item, stepStage),
      title: item?.title,
      subTitle: handleActionsSteps(item, {
        currentStage: `${input?.current_stage}`.toLowerCase(),
        goToCurrentStage,
        t,
        onChangeContractStates,
      }),
      description: item?.message,
      key: item.sort,
    })
  );
  return data;
};

export const handlePageTitle = ({
  data,
  currentStageKey,
  stepStage,
  translate,
  name,
}) => {
  const currentStageTitle = data?.stages?.filter(
    (item) => item.sort === stepStage
  )?.[0]?.title;

  if (PMA_STAGES.AMOUNT === currentStageKey)
    return `سرمایه‌گذاری در سبد ${name}`;

  if (PMA_STAGES.STAGES === currentStageKey)
    return translate("pma-onboarding.create-asset");

  return currentStageTitle;
};

export const bankDataTransformer = (input) => {
  const data = [];
  input?.map((item) =>
    data.push({
      value: item?.accountNumber,
      label2: (
        <div className="flex flex-col space-y-2 mt-4 first:mt-0">
          <span className="body-14px-bold">{item?.bankName}</span>
          <span className="body-14px-medium"> شماره شبا: {item?.iban}</span>
          <span className="body-14px-medium flex">
            شماره حساب:{" "}
            <span className=" flex flex-row-reverse">
              {item?.accountNumber}
            </span>
          </span>
        </div>
      ),
      label: (
        <div className="flex">
          <span className="body-14px-bold ml-2">{item?.bankName}</span>
          <span className="body-14px-medium">{item?.accountNumber}</span>
        </div>
      ),
    })
  );
  return data;
};

export const intiUserInfo = (userInfo = []) => {
  const data = {};
  userInfo?.forEach((item) => {
    data[item.key] = item.value;
  });

  return data;
};

export const backSteps = ({
  planId,
  currentStageKey,
  navigate,
  setCurrentStageKey,
  startOnbChecking,
}) => {
  switch (currentStageKey) {
    case PMA_STAGES.CREATING_PRX:
    case PMA_STAGES.STAGES:
    case PMA_STAGES.AMOUNT:
      return navigate(`/pma/${planId}`, { replace: true });

    case PMA_STAGES.PAYMENT:
    case PMA_STAGES.ADDITIONAL_AMOUNT:
      return setCurrentStageKey(PMA_STAGES.STAGES);

    case PMA_STAGES.RISK:
    case PMA_STAGES.SIGN_CONTRACT:
      return startOnbChecking({ isShowStages: true });

    default:
      return "";
  }
};

export const handleStagesButtonText = ({
  additionalAmountIsDone,
  additionalAmountStage,
  createPrxIsDone,
  createPrxStage,
  failed,
  isFindAdditionalAmount,
  stepStage,
  t,
}) => {
  if (stepStage === 0) return t("start");
  if (failed) return t("pma-onboarding.failed-restart");

  if (
    createPrxIsDone ||
    (additionalAmountIsDone && additionalAmountStage) ||
    (createPrxStage && !isFindAdditionalAmount)
  )
    return t("close");

  if (
    isFindAdditionalAmount &&
    !additionalAmountIsDone &&
    (createPrxStage || additionalAmountStage)
  )
    return t("pma-onboarding.additional-amount");

  return t("pma-onboarding.button-continue");
};

export const createPrxStates = (stage) => {
  const { key, info_status, status } = stage;

  const isCreatePtxStage = `${key}`.toLowerCase() === PMA_STAGES.CREATING_PRX;

  return {
    isDone: status === "DONE" && ["OPEN", "LOCK"].includes(info_status),
    isStage: isCreatePtxStage,
  };
};

export const additionalAmountStates = (stage) => {
  const { key, info_status, status } = stage;

  const isAdditionalAmountStage =
    `${key}`.toLowerCase() === PMA_STAGES.ADDITIONAL_AMOUNT;

  return {
    isDone: status === "DONE" && info_status === "CLOSE",
    isStage: isAdditionalAmountStage,
  };
};

export const convertAmountFaToEn = (value) =>
  digitsFaToEn(digitsArToFa(`${value}`))?.replace(/[^0-9]/g, "");

export const initialsRiskData = ({
  currentStageDetails,
  data,
  lastSurveyData,
}) => {
  const newCurrentStage = { ...currentStageDetails };
  if (newCurrentStage?.fields?.[0]?.key)
    newCurrentStage.fields[0].value = lastSurveyData?.user_survey_id;

  const newData = {
    ...data,
    stages: data?.stages?.map((item) =>
      item.key === data?.current_stage ? newCurrentStage : item
    ),
  };

  return newData;
};

export const initialsContractData = ({
  addressData,
  currentStageDetails,
  data,
  value,
}) => {
  const newCurrentStage = { ...currentStageDetails };

  newCurrentStage?.fields?.forEach((item) => {
    if (item.key === "otp_code") {
      item.value = Number(value.otp);
    }

    if (item.key === "email_address") {
      item.value = addressData?.email_address;
    }

    if (item.key === "address_id") {
      item.value = addressData?.id || addressData?.address_id;
    }
  });

  const newData = {
    ...data,
    stages: data?.stages?.map((item) =>
      item.key === data?.current_stage ? newCurrentStage : item
    ),
  };

  return newData;
};
